import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const PercentFormField = ({ fieldDef }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled } = useFormFieldDef(fieldDef);

  const displayValue = Number.isFinite(Number(value)) ? Number(value) * 100 : '';

  return (
    <NumericFormat
      customInput={TextField}
      thousandSeparator
      decimalScale={fieldDef.decimalPrecision}
      fixedDecimalScale
      suffix="%"
      value={displayValue}
      onValueChange={(values) => {
        setValue(values.floatValue == null ? '' : values.floatValue / 100);
      }}
      onBlur={onBlur}
      error={!disabled && error}
      helperText={helperText}
      label={label}
      disabled={disabled}
    />
  );
};